import * as React from 'react';
import ShippingMethodListItem from './ShippingMethodListItem';
import Section from './Section';
import { ShippingMethod } from '../shipping-method';

const active = (methods: ShippingMethod[]) =>
  methods.filter((item: ShippingMethod) => item.available);
const inactive = (methods: ShippingMethod[]) =>
  methods.filter((item: ShippingMethod) => !item.available);

const mapToShippingMethodItem = (method: ShippingMethod, index: number) => (
  <ShippingMethodListItem method={method} key={index} index={index} />
);

type Props = {
  methods: ShippingMethod[];
};

export default function ShippingMethodList(props: Props) {
  const inactiveMethods = inactive(props.methods);

  return (
    <React.Fragment>
      <Section title="Active">
        {active(props.methods).map(mapToShippingMethodItem)}
      </Section>
      {inactiveMethods.length > 0 && (
        <Section title="Inactive">
          {inactiveMethods.map(mapToShippingMethodItem)}
        </Section>
      )}
    </React.Fragment>
  );
}
